module.exports = __webpack_public_path__ + "img/img-21846a.png";